import { bool } from "prop-types";
import React from "react";

import styled from "styled-components/macro";
import { colors } from "theme/constants";

import { PREPARING_EXPORT } from "Flocknote/GlobalComponents/Modal/contentKeys";
import { useNetworkMetadata } from "Flocknote/apiHooks";
import flocknoteStateHooks from "Flocknote/stateHooks";

import FnrTypography from "FnrTypography";

import FnrButton from "UI/FnrButton3";

import ErrorMessage from "./ErrorMessage";
import { useGetBrisbaneReport } from "./api/queries";

export default function BrisbaneReport({ showBrisbaneDownload }) {
  const [{ hasQueuedExports }] = useNetworkMetadata();
  const [, { openModal }] = flocknoteStateHooks.useModal();

  const onSuccess = (resp) => {
    openModal(PREPARING_EXPORT, { exportID: resp.exportID });
    window.checkBackgroundJobs();
  };

  const { mutate, isLoading, isError, error } = useGetBrisbaneReport({
    onSuccess,
  });

  const handleClick = () => {
    if (isLoading) return;
    mutate();
  };

  if (!hasQueuedExports || !showBrisbaneDownload) return null;

  return (
    <Wrapper>
      <FnrTypography type="header" fontSize="lg" color="white">
        All Active Members Report
      </FnrTypography>

      <FnrButton
        onClick={handleClick}
        disabled={isLoading}
        size="small"
        color={colors.lightBlue}
        fullWidth
      >
        <SFnrTypography type="copy" bold color={colors.darkBlue}>
          Export
        </SFnrTypography>
      </FnrButton>

      <ErrorMessage show={isError} message={error?.message} />
    </Wrapper>
  );
}

BrisbaneReport.propTypes = {
  showBrisbaneDownload: bool,
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
  background-color: #2867ac;
  color: white;
`;

const SFnrTypography = styled(FnrTypography)`
  text-shadow: none;
`;